module.exports = __webpack_public_path__ + "static/media/fly0130.ae767dd4.webp";